import { NavLink, generatePath } from 'react-router-dom';
import { IconLoader, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';

// types
import ROUTES from '../../../routes';
import { ColumnGroupsTypes } from './types';

// components
import ColumnHead from './column-head';

// styles
import cn from './column.module.css';

const ColumnGroups = ({
  groups,
  categoryId,
  primaryAccountId,
  path,
  isLoading,
  currentCategory,
}: ColumnGroupsTypes): React.JSX.Element => {
  const { activePermissions } = useAppSelector((state) => state.root);

  let content;

  if (isLoading) {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = groups?.map((item) => (
      <div
        className={`${cn.columnItemWrapper} ${
          item?.isClientAccount ? cn.columnItemWrapperEditable : ''
        }`}
        key={item.id}
      >
        <NavLink
          className={cn.columnItem}
          to={generatePath(ROUTES.GROUPS, {
            categoryId: categoryId as string,
            groupId: item.id,
          })}
        >
          <span className={cn.columnItemNumber}>{item?.number}</span>
          {item.description}
        </NavLink>
        {categoryId &&
          item.isClientAccount &&
          activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_EDIT_GROUP_ACTION,
          ) && (
            <NavLink
              to={generatePath(ROUTES.GROUP_EDIT, {
                categoryId,
                groupId: item.id,
                primaryAccountId: primaryAccountId as string,
              })}
              className={cn.editButton}
            >
              edit
            </NavLink>
          )}
      </div>
    ));
  }

  return (
    <div className={cn.column}>
      <ColumnHead
        title="Group"
        path={path}
        linkIsVisible={Boolean(
          activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_ADD_GROUP_ACTION,
          ) &&
          currentCategory &&
          currentCategory.active,
        )}
      />
      {content}
    </div>
  );
};

export default ColumnGroups;
